import React from "react";
import "../section2/section2.css";
function Section2() {
  return (
    <>
      <div class="word">
        <div class="sec">
          <img
            src="https://uploads-ssl.webflow.com/5e62759ab81ddc4f5815a3b6/5e62759b0447368014dafb9c_trophy.svg"
            alt=""
          />
          <h3>
            “With almost 25 years of online auction experience, we encourage our
            clients to think of us as a resource they can always rely on for
            advice and guidance. ”
          </h3>
        </div>
      </div>
    </>
  );
}
export default Section2;
